const initOffice = key => ({
  key,
  criteria: '',
  name: 'New office',
  voteForNumber: 1,
  order: 0
})

export default initOffice
